<div class="welcome-banner d-flex align-items-center justify-content-between mb-4">
  <!--church name and info -->
  <div class="banner-text">
    <h2 class="church-name mb-1">{{ churchName }}</h2>
    <p class="welcome-text mb-2">Welcome to Church</p>

    <div class="banner-info-pills">
      <div *ngIf="churchUnitCode" class="info-pill">
        <i class="fas fa-church me-2"></i>Church Unit Code: {{ churchUnitCode }}
      </div>
      <div *ngIf="officerName" class="info-pill">
        <i class="fas fa-user me-2"></i>{{ officerName }}
      </div>
    </div>
  </div>

  <!--church Logo -->
  <div class="banner-logo">
    <img [src]="churchLogo" [alt]="churchName + ' Logo'" />
  </div>
</div>